import { useEffect } from 'react';

const DEFAULT_SITE_NAME = 'WealthDost';
const DEFAULT_TITLE = 'WealthDost | Trust-First Finance Community';
const DEFAULT_DESCRIPTION =
  'WealthDost is India’s trust-first finance community for credible expert insights, real-time discussions, and investor tribes.';
const DEFAULT_KEYWORDS =
  'WealthDost, investing community, stock discussions, finance experts, investor tribes, India';
const DEFAULT_OG_IMAGE_PATH = '/wd-og.png';

const ensureMetaTag = (selector, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement('meta');
    Object.entries(attributes).forEach(([key, value]) => {
      element.setAttribute(key, value);
    });
    document.head.appendChild(element);
  }

  return element;
};

const ensureLinkTag = (selector, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement('link');
    Object.entries(attributes).forEach(([key, value]) => {
      element.setAttribute(key, value);
    });
    document.head.appendChild(element);
  }

  return element;
};

const buildAbsoluteUrl = (pathOrUrl) => {
  if (!pathOrUrl) return null;
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;

  const origin = window.location.origin;
  return new URL(pathOrUrl, origin).toString();
};

const Seo = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  keywords = DEFAULT_KEYWORDS,
  image = DEFAULT_OG_IMAGE_PATH,
  type = 'website',
  path = '/',
  noIndex = false
}) => {
  useEffect(() => {
    const canonicalUrl = buildAbsoluteUrl(path || window.location.pathname);
    const imageUrl = buildAbsoluteUrl(image || DEFAULT_OG_IMAGE_PATH);
    const robotsContent = noIndex ? 'noindex, nofollow' : 'index, follow';

    document.title = title;

    ensureMetaTag('meta[name="description"]', { name: 'description' }).setAttribute('content', description);
    ensureMetaTag('meta[name="keywords"]', { name: 'keywords' }).setAttribute('content', keywords);
    ensureMetaTag('meta[name="robots"]', { name: 'robots' }).setAttribute('content', robotsContent);

    ensureMetaTag('meta[property="og:site_name"]', { property: 'og:site_name' }).setAttribute('content', DEFAULT_SITE_NAME);
    ensureMetaTag('meta[property="og:title"]', { property: 'og:title' }).setAttribute('content', title);
    ensureMetaTag('meta[property="og:description"]', { property: 'og:description' }).setAttribute('content', description);
    ensureMetaTag('meta[property="og:type"]', { property: 'og:type' }).setAttribute('content', type);
    ensureMetaTag('meta[property="og:url"]', { property: 'og:url' }).setAttribute('content', canonicalUrl);
    ensureMetaTag('meta[property="og:image"]', { property: 'og:image' }).setAttribute('content', imageUrl);

    ensureMetaTag('meta[name="twitter:card"]', { name: 'twitter:card' }).setAttribute('content', 'summary_large_image');
    ensureMetaTag('meta[name="twitter:title"]', { name: 'twitter:title' }).setAttribute('content', title);
    ensureMetaTag('meta[name="twitter:description"]', { name: 'twitter:description' }).setAttribute('content', description);
    ensureMetaTag('meta[name="twitter:image"]', { name: 'twitter:image' }).setAttribute('content', imageUrl);

    ensureLinkTag('link[rel="canonical"]', { rel: 'canonical' }).setAttribute('href', canonicalUrl);
  }, [description, image, keywords, noIndex, path, title, type]);

  return null;
};

export default Seo;
